import { type ReactNode, useEffect, useRef, useState } from 'react';
import { type ColumnDef, EXTRA_COLUMNS } from '@/lib/columns';
import { zoneLabel, type Zone } from '@/lib/format';
import { Icon } from './Icon';

export interface ColumnsHeaderProps {
    columns: readonly ColumnDef[];
    zone: Zone;
    onZone: () => void;
    onToggle: (key: string) => void;
}

// The list's header: the clock it shows (a click switches Rome and UTC), the columns, and the menu that adds them.
export function ColumnsHeader(props: ColumnsHeaderProps): ReactNode {
    const [open, setOpen] = useState(false);
    const menu = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!open) {
            return;
        }
        const close = (event: MouseEvent): void => {
            if (!menu.current?.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        window.addEventListener('mousedown', close);

        return () => window.removeEventListener('mousedown', close);
    }, [open]);
    const shown = new Set(props.columns.map((column) => column.key));

    return (
        <div className="cols">
            <button className="ch" onClick={props.onZone} title="Show the time in Rome or UTC (U)">
                {zoneLabel(props.zone)} time <span className="swap">⇄</span>
            </button>
            <span>Level</span>
            <span>Service</span>
            <span className="modh">Module</span>
            {props.columns.map((column) => (
                <span key={column.key} className="ch x">
                    {column.label}
                    <button title={`Remove the ${column.label.toLowerCase()} column`} onClick={() => props.onToggle(column.key)}>
                        <Icon name="x" size={12} />
                    </button>
                </span>
            ))}
            <span className="ch last">
                Message
                <span className="colmenu" ref={menu}>
                    <button className={`addcol ${open ? 'on' : ''}`} onClick={() => setOpen(!open)} title="Add or remove columns">
                        <Icon name="plus" size={13} /> Columns
                    </button>
                    {open && (
                        <div className="colpop float">
                            {EXTRA_COLUMNS.map((column) => (
                                <button key={column.key} className={shown.has(column.key) ? 'on' : ''} onClick={() => props.onToggle(column.key)}>
                                    <span className="tick">
                                        <Icon name="check" size={12} />
                                    </span>
                                    {column.label}
                                </button>
                            ))}
                        </div>
                    )}
                </span>
            </span>
        </div>
    );
}
